/**
 * A arte de um apetrecho: a do catálogo quando existe, a peça do pacote de pesca quando não.
 *
 * Mora aqui, e não dentro do `Apetrechos.vue`, porque desde 11/09/2026 são dois lugares que
 * desenham apetrecho — o baú dos encaixes e a grade da mochila. Uma cópia do caminho em cada
 * um é como a mesma boia sairia com arte num e quadrado vazio no outro. Quando o CMS subir a
 * arte (`imagem`), ela vence.
 */
const RESERVA_DO_SLOT = {
  anzol: '/images/ui/apetrecho-anzol.png',
  boia: '/images/ui/apetrecho-boia.png',
  caixa: '/images/ui/apetrecho-caixa.png',
};

export function arteDoApetrecho(apetrecho) {
  return apetrecho?.imagem || RESERVA_DO_SLOT[apetrecho?.slot] || null;
}
